import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { FacebookIntegration } from '../domain/facebook';

export type FacebookIntegrationsState = {
  facebookIntegrations: FacebookIntegration[];
  isGettingIntegrations: boolean;
  refetchIntegrations: () => void;
  hasIntegrationsError: boolean;
  hasReceivedIntegrations: boolean;
  removeFacebookIntegration: (id: number) => void;
  selectedId: number | null;
  targetId: (id: number) => void;
  isUnsubscribing: boolean;
  isNotUnsubscribed: boolean;
  isUnsubscribed: boolean;
  unsubscribe: (id: number) => void;
};

export const FacebookIntegrationsContext = createContext<FacebookIntegrationsState>({
  facebookIntegrations: [],
  isGettingIntegrations: false,
  refetchIntegrations: noop,
  hasIntegrationsError: false,
  hasReceivedIntegrations: false,
  removeFacebookIntegration: noop,
  selectedId: null,
  targetId: noop,
  unsubscribe: noop,
  isUnsubscribing: false,
  isNotUnsubscribed: false,
  isUnsubscribed: false,
});

export const useFacebookIntegrationContext = () => useContext(FacebookIntegrationsContext);
